import { ParsedUrlQuery } from 'querystring'
import { bff } from '../../env'
import { BffProduct, Product, ProductError, ProductSource, ProductType, SanityProduct } from '../../types/product'
import { sanity } from '../sanity/client'
import { productQuery } from '../sanity/queries/products'

const endpoint = `${bff}/products`

export const getProductById = async ({
  id,
  source,
  from,
  to,
}: {
  id: number | string
  source: ProductSource
  from?: string
  to?: string
}): Promise<BffProduct | ProductError> => {
  let response
  // handle scenarios where ID does not exist
  if (id !== null) {
    const request = new URL(`${endpoint}/${id}`)
    request.searchParams.set('source', source)
    if (from) request.searchParams.set('from', from)
    if (to) request.searchParams.set('to', to)

    response = await fetch(request)
  }

  return response?.json()
}

export const getCheckoutProductById = async ({
  product,
  source,
  from,
  to,
  quantity,
}: ParsedUrlQuery): Promise<Product> => {
  const request = new URL(`${endpoint}/${product}`)
  request.searchParams.set('source', source as string)
  if (from) request.searchParams.set('from', from as string)
  if (to) request.searchParams.set('to', to as string)
  if (quantity) request.searchParams.set('quantity', quantity as string)

  const [{ type, ...sanityProduct }, bffProduct]: [SanityProduct, BffProduct] = await Promise.all([
    sanity.fetch<SanityProduct>(productQuery(product as string, source as string)),
    fetch(request).then((response) => response.json()),
  ])

  return { ...sanityProduct, ...bffProduct, type }
}

export const getProducts = async (
  type: ProductType,
  smProductIds: string[]
): Promise<{ products: BffProduct[]; quantity?: number } | { statusCode: number; message: string }> => {
  const request = new URL(endpoint)
  request.searchParams.set('productType', type)
  request.searchParams.set('smProductIds', smProductIds.join(','))

  const response = await fetch(request)
  const data = await response.json()

  return data
}
